import { render, staticRenderFns } from "./DSArrowDownIcon.vue?vue&type=template&id=fe6c87c4&"
import script from "./DSArrowDownIcon.vue?vue&type=script&lang=js&"
export * from "./DSArrowDownIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports